<template>
    <div v-if="loan && loan.ledger_status === 'account_closed'" class="bg-red-50 border border-red-200 rounded-lg p-4 mt-4">
        <div class="flex items-start">
            <div>
                <h3 class="text-lg font-semibold text-red-800 mb-2">‼️ Account Closed</h3>
                <p class="text-red-700">
                    Your account has been flagged as closed or without income. To keep your account from defaulting, connnect to a new bank account.
                </p>
            </div>
        </div>

        <a
            href="/account/change-bank-required"
            class="block w-full no-underline mt-4 bg-red-600 hover:bg-red-700 border border-red-700 rounded text-white text-center text-lg font-semibold py-3 transition-colors duration-200" 
            data-testid="update-banking-details"
        >
            Update Banking Details
        </a>
    </div>
</template>

<script>
export default {
    name: "LoanAccountClosed",
    mixins: [
        require('../mixins/InteractsWithLoans').default
    ],
};
</script>